import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import "react-slideshow-image/dist/styles.css";
import '../src/assets/css/custom.css';
import '../src/assets/css/custom-new.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { hydrateRoot, createRoot } from 'react-dom/client';

const rootElement = document.getElementById('root') as HTMLElement;

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, 
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

reportWebVitals();
